import React, { useEffect } from "react";

export const CustomeSearch = ({
  intl,
  handleBlur,
  values,
  setFieldValue,
  handleSubmit,
  topData,
   type,
}) => {
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      // Send Axios request here
      handleSubmit();
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.search, values?.searchText]);
  return (
    <div style={{ position: "relative" }}>
      <input
        style={{ paddingRight: "40px" }}
        type="text"
        className="form-control"
        name={type === "pro"?"search":"searchText"}
        placeholder={intl.formatMessage({ id: "Search" })}
        onBlur={handleBlur}
        value={type === "pro"?values?.search:values?.search}
        onChange={(e) => {
          setFieldValue("searchTextBook", "");
          setFieldValue(type === "pro"?"search":"searchText", e.target.value);
          //   setTimeout(() => {
          //     handleSubmit();
          //   }, 1000);
        }}
      />
      <i
        style={{
          position: "absolute",
          top: topData ? topData : "50%",
          transform: "translateY(-50%)",
          right: "15px",
        }}
        className="fa fa-search"
        aria-hidden="true"
      ></i>
    </div>
  );
};
